import { Injectable } from '@angular/core';
import { IGlobalError } from '../models/global-error.model';

@Injectable({
  providedIn: 'root',
})
export class LogErrorService {
  constructor() {}

  logError(error: Partial<IGlobalError>): void {
    const errorDetails = {
      ...error,
      timestamp: new Date(),
    };
    console.error('Logging error in service:', errorDetails);
    // we have to implement the logic to send this error to the server
  }
}
